import { Tween, Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import TransformComponent from '../../../Component/Transform';
import Point from '../../../Utility/Point';
import SpriteComponent from '../../../Component/Render/Sprite';
import Crop from '../../../Prototype/World/Crop';
import { GrowthStage } from '../../../State/World/IFieldData';
import { Random } from '../../../Utility/Random';
import CropComponent from '../../../Component/Map/Crop';
import { delay } from '../../../Utility/Task/TaskQueue';

export interface ICropTransitionParams {
    amplitude: number;
    duration: number;
    stage: GrowthStage;
    delay?: number;
    transitionTexture?: string;
}

export class CropTransition extends AnimationClip {
    public *execute(
        crop: Crop,
        meta?: ICropTransitionParams
    ): IterableIterator<number> {
        try {
            // Create random delay to vary animation
            yield* delay(Math.random() * 250);

            const cropComponent: CropComponent = crop.getComponent(
                CropComponent
            );
            const transform: TransformComponent = crop.cropSprite.getComponent(
                TransformComponent
            );
            const sprite: SpriteComponent = crop.cropSprite.getComponent(
                SpriteComponent
            );
            const cropScaleTween: Tween = this.getTween(transform.scale).easing(
                Easing.Quadratic.InOut
            );
            const baseScale: Point = new Point(1, 1);
            const maxScale: Point = new Point(
                baseScale.x * (1 + meta.amplitude),
                baseScale.y * (1 + meta.amplitude)
            );

            if (meta.transitionTexture !== undefined) {
                sprite.texture = meta.transitionTexture;
                yield* delay(meta.delay ? meta.delay : 0);
            }

            yield* delay(Random.int(0, 450));

            // Bounce and disappear
            yield* this.scaleTweenTo(cropScaleTween, maxScale, meta.duration);
            yield* this.scaleTweenTo(
                cropScaleTween,
                new Point(0, 0),
                meta.duration
            );

            if (!meta.transitionTexture) {
                yield* delay(meta.delay ? meta.delay : 0);
            }

            yield* delay(Random.int(0, 450));

            // Set new texture
            sprite.texture = Random.getRandomWeighted(
                cropComponent.textures[meta.stage]
            );

            // Bounce crop back
            yield* this.scaleTweenTo(cropScaleTween, maxScale, meta.duration);
            yield* this.scaleTweenTo(cropScaleTween, baseScale, meta.duration);
        } catch (e) {
            console.warn(e);
        }
    }
    private *scaleTweenTo(
        tween: Tween,
        scale: Point,
        delay: number
    ): IterableIterator<number> {
        tween.to({ x: scale.x, y: scale.y }, delay);
        yield* this.startTween(tween);
    }
}
